/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Input, message, Typography } from "antd";
import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FormItemRequiredRule } from "../../Utility/Constants";
import { decrypt } from "Utility/Common/Methods";
import AuthRightContent from "Components/AuthRightContent";

function VerifyEmail(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isLoading, setisLoading] = useState(false);
  const [showEmail, setShowEmail] = useState("");

  useEffect(() => {
    let code = location?.search?.split("code=")?.[1]?.split("+email=")?.[0];
    let email = location?.search?.split("email=")?.[1];
    setShowEmail(location?.state?.email);

    if (code && email) {
      handleSubmit({ email, code });
      return;
    }

    if (location?.state?.email) {
      form.setFieldsValue({ email: location?.state?.email });
    } else {
      navigate("/");
    }
  }, [location]);

  const handleSubmit = async (data) => {
    let UserCredentials = {
      email: location?.state?.email ?? data?.email,
      password: location?.state?.password,
    };

    let localItem = localStorage.getItem("cache");
    if (localItem && localItem?.length > 0) {
      let jsonString = decrypt(localItem, process.env.REACT_APP_SECUTRY_KEY);
      try {
        let credentials = JSON.parse(jsonString);
        UserCredentials.password = credentials.password;
        UserCredentials.email = credentials.email;
        localStorage.removeItem("cache");
      } catch (error) {
        console.log(error);
      }
    }

    setisLoading(true);
    try {
      await Auth.confirmSignUp(showEmail, String(data?.code));
      message.success("Email Verified!!");

      navigate("/login", {
        state: {
          ...UserCredentials,
          directLogin: Boolean(UserCredentials?.password),
        },
      });
      setisLoading(false);
    } catch (error) {
      console.log(error, "verify email error");
      setisLoading(false);
      message.error(error?.message);
    }
  };

  const handleResendCode = async () => {
    setisLoading(true);

    let email = form.getFieldValue("email");
    try {
      await Auth.resendSignUp(email);
      message.success("A new confirmation code has been sent.");
      setisLoading(false);
    } catch (error) {
      console.log("error signing up:", error);
      message.error(error.message);
      setisLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="max-w-5xl w-full">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left side - Content */}
          <div className="space-y-14">
            {/* Header */}
            <div>
              <h1
                className="font-bold text-gray-900 leading-tight"
                style={{ fontSize: "32px" }}
              >
                Verify your email
              </h1>
              <p className="text-lg text-gray-600 mt-2">
                We've sent a verification code to{" "}
                <span className="font-medium">{showEmail}</span>
              </p>
            </div>

            {/* Form */}
            <div className="space-y-12">
              <Form
                onFinish={handleSubmit}
                form={form}
                layout="vertical"
                requiredMark={false}
                name="verify-email"
                className="space-y-4"
              >
                <Form.Item name="code" rules={[FormItemRequiredRule]}>
                  <Input.OTP
                    length={6}
                    className="input-border py-3"
                    size="large"
                    inputClassName="py-3"
                  />
                </Form.Item>

                <Button
                  htmlType="submit"
                  type="primary"
                  size="large"
                  loading={isLoading}
                  className="w-full h-12 text-base font-semibold rounded-lg bg-primary"
                >
                  Verify Email
                </Button>
              </Form>

              <div className="space-y-4 text-center">
                <div>
                  <Link to="/login" className="text-sm text-gray-600 hover:underline">
                    Already verified?{" "}
                    <span className="text-primary">Sign in</span>
                  </Link>
                </div>
                <div>
                  <Typography.Text
                    className="text-sm text-blue-500 underline cursor-pointer"
                    onClick={handleResendCode}
                  >
                    Resend verification code
                  </Typography.Text>
                </div>
              </div>
            </div>
          </div>

          {/* Right side content */}
          <AuthRightContent />
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
